module.exports = {
  about: {
    title: 'À propos de Webjomp',
    desc: {
      1: 'Fondateur de Webjomp, François-Xavier Lemire obtient un diplôme en informatique avec une majeure en génie logiciel à ' +
        'l\'Université McGill en 2016. Il est aussi diplômé en droit de l\'Université de Montréal depuis 2010 et membre du ' +
        'Barreau du Québec depuis 2011, auparavant praticien au sein du cabinet {lla}',
      2: 'François-Xavier a développé ses talents d\'ingénieur logiciel en touchant à plusieurs disciplines, dont la {fintech} chez ' +
        '{morgan}, les jeux vidéo ({skylanders}) chez {beenox}, et la publicité mobile chez {vungle}, à San Francisco.',
      3: 'S\'il n\'est pas en train de réfléchir à sa prochaine application, il est soit en train de pratiquer la trompette, ' +
        'de déguster un bon scotch ou bien de boxer!',
      4: 'N\'hésitez pas à rester connecté!',
    },
  },
  banner: {
    header: {
      default: 'Le web, ',
      span: 'repensé',
    },
    desc: 'Création de sites web, d\'applications mobiles et {br}conseils pour solutions d\'affaires.',
    cta: 'En savoir plus',
  },
  contact: {
    title: 'Écrivez-nous',
    form: {
      name: 'Nom',
      email: 'Courriel',
      topic: 'Sujet',
      message: 'Message',
      receiveCopy: 'Recevoir une copie',
      send: 'Envoyer',
      confirm: {
        success: 'ReCaptcha résolu? Nous vous contacterons sous peu!',
        error: 'ERREUR: L\'envoi a échoué. Veuillez réessayer plus tard.',
        popup: 'ERREUR: Autorisez les pop-ups pour compléter un reCaptcha.',
        close: 'Fermer',
      },
    },
    email: 'Courriel',
    phone: 'Téléphone',
    where: 'Lieu',
  },
  menu: {
    home: 'Accueil',
    contact: 'Contact',
    about: {
      title: 'À propos',
      page: 'apropos',
    },
    services: {
      title: 'Nos services',
      page: 'services',
    },
  },
  landing: {
    tiles: {
      moderne: {
        title: 'Des sites Web modernes',
        desc: 'Attrayez votre clientèle avec un look frais et captivant.',
      },
      agile: {
        title: 'Agiles',
        desc: 'Soyez impliqué dans les itérations menant à la création du site afin d\'obtenir le résultat que vous recherchez.',
      },
      beton: {
        title: 'Bétons',
        desc: 'Nous adoptons les meilleures pratiques établies par l\'industrie afin de vous fournir un site performant, sans failles, ' +
          'à l\'épreuve du temps.',
      },
      adaptatif: {
        title: 'Adaptatifs',
        desc: 'Ayez un site attrayant, tant sur mobile que sur ordinateur.',
      },
      clair: {
        title: 'Que vous comprendrez',
        desc: 'Nous prenons le temps nécessaire pour répondre à toutes vos questions.',
      },
      abordable: {
        title: 'À des prix réalistes',
        desc: 'Nous minimisons les frais accessoires tels que l\'hébergement et acquisition de domaine.',
      },
    },
    services: {
      title: 'Nos services',
      websites: 'Sites Web',
      apps: 'Applications',
      consulting: 'Solutions d\'affaires',
      cta: 'En savoir plus',
    },
    clients: { title: 'Quelques-uns de nos clients' },
  },
  services: {
    title: 'Webjomp - Services',
    header: 'Nos services',
    desc: 'Création de sites Web, d\'applications mobiles et conseils pour solutions d\'affaires.',
    main: {
      header: 'Plus que des sites Web',
      desc: 'En plus de la création de sites Web, Webjomp offre une gamme variée de services, comme la conception d\'applications ' +
        'mobiles pour Android, iOS et Windows Phones, ou encore la création de logiciels personnalisés aux besoins de votre industrie.',
      cta: 'En savoir plus',
    },
    websites: {
      header: 'Sites Web',
      list: {
        1: 'Commerce électronique',
        2: 'Sites adaptatifs',
        3: 'Blogues',
        4: 'Référencement (SEO)',
        5: 'Envoi massif de courriels',
        6: 'Rédaction, révision et traduction',
        7: 'Conceptions originales et refontes',
        8: 'Pages statiques et dynamiques',
        9: 'Cartes et agendas',
        10: 'Réseaux sociaux',
        11: 'Plateforme de messagerie',
        12: 'Formulaires de contact',
        13: 'Analyse de données',
        14: 'Publicité',
        15: 'Acquisition de domaine',
        16: 'Hébergement Web',
      },
      more: {
        content: 'Vos besoins ne se retrouvent pas dans cette liste? N\'hésitez pas à {anchor}!',
        anchor: 'communiquer avec nous',
      },
    },
    apps: {
      header: 'Applications mobiles',
      desc: {
        p1: 'Nous développons pour Android, iOS et Windows Phones.',
        p2: 'Vous avez une idée d\'application en tête? Nous vous aidons à la concrétiser à travers ces étapes: cerner les requis, ' +
          'concevoir le look, développer et tester les fonctionnalités, publier l\'application.',
        p3: 'Le travail ne s\'arrête pas là! Nous garantissons le bon fonctionnement de votre application en la maintenant à jour ' +
          'et en améliorant la conception et les fonctionnalités grâce à l\'analyse de données de vos usagers.',
      },
    },
    consulting: {
      header: 'Solutions d\'affaires',
      desc: 'Concentrez-vous sur les tâches dont vous seul êtes le professionnel.',
      software: {
        header: 'Développement de logiciels personnalisés',
        desc: 'Visualisation de données, automatisation de tâches routinières.',
      },
      solutions: {
        header: 'Installation de logiciels',
        desc: 'Facturation, bureautique, comptabilité, salaires, gestion de projet, gestion de clients.',
      },
      pm: {
        header: 'Gestion de projet',
        desc: 'Présentations clients, gestion de l\'échéancier, contrôle de qualité et satisfaction.',
      },
      strategy: {
        header: 'Stratégies d\'affaires',
        desc: 'Publicité, référencement, analyse de données, adoption de technologies, conseils pour croissance rapide.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/data/messages/fr.js